function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Imagem-5",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_61",
  "data-name": "Caminho 61",
  d: "M268.457-121.4a5.334,5.334,0,0,0-2.726,1.135c-.4.368-.81,1.179-.678,1.3a7.467,7.467,0,0,0,1.414.162c.987.074,1.356.059,1.356-.074,0-.265.914-.751,1.444-.751a1.757,1.757,0,0,1,1.414.663,4.021,4.021,0,0,1,.088.9c0,.619-.015.663-.324.56a4.753,4.753,0,0,0-4.641.575,2.662,2.662,0,0,0,1.12,4.627c1.179.339,2.092.177,3.743-.663.059-.029.1.118.1.324v.383h4.568v-2.357h-1l-.059-2.254c-.059-2.549-.25-3.168-1.135-3.757A7.786,7.786,0,0,0,268.457-121.4Zm1.8,5.363c.486.206.516.265.516.884s-.029.663-.634.958c-.8.383-1,.383-1.488,0a1.129,1.129,0,0,1,0-1.739A1.419,1.419,0,0,1,270.254-116.036Z",
  transform: "translate(-231.562 124.641)",
  fill: "#ff5763"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_62",
  "data-name": "Caminho 62",
  d: "M199.05-120.794a4.573,4.573,0,0,0-3.05,4.45c0,2.814,2.416,4.848,5.452,4.582a4.829,4.829,0,0,0,3.079-1.223c.619-.56,1.193-1.444,1.031-1.591-.074-.059-2.549-.825-2.564-.781a2.425,2.425,0,0,1-1.017,1.193,1.678,1.678,0,0,1-2.416-1.061c-.545-1.8.236-3.448,1.635-3.477a1.659,1.659,0,0,1,1.665,1.031l.206.5h2.357v-3.684h-1.105c-1.061,0-1.105.015-1.105.339v.354l-.825-.427a3.46,3.46,0,0,0-1.812-.413A6.76,6.76,0,0,0,199.05-120.794Z",
  transform: "translate(-172.852 124.242)",
  fill: "#ff5763"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_63",
  "data-name": "Caminho 63",
  d: "M346.557-120.779a4.666,4.666,0,0,0-1.871,1.694c-.25.368-.25.354-.25-.707l-.015-1.061H340v2.387l.634-.059.619-.044.044,2.181.044,2.166H340v2.328h6.188v-2.328h-1.473v-.81a2.719,2.719,0,0,1,.825-2.166,2.966,2.966,0,0,1,2.063-.648l.354.088V-121h-.4A4.285,4.285,0,0,0,346.557-120.779Z",
  transform: "translate(-295.635 124.242)",
  fill: "#ff5763"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_64",
  "data-name": "Caminho 64",
  d: "M399.6-120.7a4.9,4.9,0,0,0-2.873,2.49,5.856,5.856,0,0,0-.029,3.949,4.77,4.77,0,0,0,2.254,2.181,4.513,4.513,0,0,0,2.446.383,4.424,4.424,0,0,0,2.431-.383,4.174,4.174,0,0,0,1.945-1.577l.265-.442-1.326-.324-1.326-.324-.516.457a1.544,1.544,0,0,1-1.3.457,1.571,1.571,0,0,1-1.65-.884c-.471-.914-.545-.884,3.109-.884h3.33l-.1-1a7.347,7.347,0,0,0-.4-1.694,5.107,5.107,0,0,0-2.652-2.372A8.071,8.071,0,0,0,399.6-120.7Zm2.593,2.063a1.568,1.568,0,0,1,.751,1.267c0,.28-.118.295-1.621.295-1.812,0-1.9-.059-1.326-1A1.632,1.632,0,0,1,402.2-118.637Z",
  transform: "translate(-343.703 124.148)",
  fill: "#ff5763"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3306",
  "data-name": "Grupo 3306",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_84",
  "data-name": "Caminho 84",
  d: "M65-196.36v1.24h1.261v7.695l-.578-.042-.578-.032v2.47h4.731v-.851l.4.315a3.141,3.141,0,0,0,2.176.673,3.828,3.828,0,0,0,3.3-1.692,4.64,4.64,0,0,0,.894-3.122,4.781,4.781,0,0,0-.809-2.986,3.563,3.563,0,0,0-3.028-1.777,3.341,3.341,0,0,0-2.4.62,3.176,3.176,0,0,1-.484.3,18.907,18.907,0,0,1-.053-2.029v-2.018l-2.418-.011H65Zm7.106,4.594a1.854,1.854,0,0,1,.578.715,3.973,3.973,0,0,1,.011,2.849,1.408,1.408,0,0,1-2.134.578,2.316,2.316,0,0,1-.725-2.029,2.479,2.479,0,0,1,.242-1.367A1.424,1.424,0,0,1,72.106-191.766Z",
  transform: "translate(-65 197.6)",
  fill: "#ff5763"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_86",
  "data-name": "Caminho 86",
  d: "M186.271-167.687a5.374,5.374,0,0,0-2.954,2.187,5.366,5.366,0,0,0,.053,5.151,5.062,5.062,0,0,0,4.552,2.176,5.517,5.517,0,0,0,3.805-1.3c.6-.536,1.072-1.3.851-1.377-.074-.021-.715-.189-1.419-.368l-1.282-.315-.463.463a1.569,1.569,0,0,1-.9.536,1.79,1.79,0,0,1-2.229-1.472l-.042-.315,3.343-.032,3.332-.021v-.683a4.413,4.413,0,0,0-1.3-3.374,5.08,5.08,0,0,0-2.218-1.261A9.158,9.158,0,0,0,186.271-167.687Zm2.576,2.386a1.645,1.645,0,0,1,.6,1.135c0,.2-.063.21-1.619.21h-1.619l.105-.431A1.656,1.656,0,0,1,188.847-165.3Z",
  transform: "translate(-170.313 170.956)",
  fill: "#ff5763"
})));

function SvgBecareLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.665,
    height: 12.783,
    viewBox: "0 0 62.665 12.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecareLogo);
export default __webpack_public_path__ + "static/media/becare-logo.c914f1c2.svg";
export { ForwardRef as ReactComponent };